import { get } from 'lodash';
import { createSelector } from 'reselect';

import getOuterUrl from '../services/get-outer-url';
import { getConfig } from '../services/config';
import * as detectRoute from '../services/detect-route';
import { getPostPageEnabled } from './app-data-selectors';

const getItems = state => get(state, 'locationHistory.items');
export const getCount = state => getItems(state) && getItems(state).length;
export const isInitialLocation = state => getCount(state) < 1;
export const getCurrentLocation = createSelector(
  getItems,
  items => items && items[items.length - 1],
);
export const getPreviousLocation = createSelector(
  getItems,
  items => items && items[items.length - 2],
);
export const getCurrentLocationPathname = state => get(getCurrentLocation(state), 'pathname');
export const getCurrentLocationOuterUrl = state => {
  const { sectionUrl: feedSectionUrl, postPageSectionUrl } = getConfig();
  const isPostPageEnabled = getPostPageEnabled(state) && postPageSectionUrl;
  const sectionUrl = isPostPageEnabled ? postPageSectionUrl : feedSectionUrl;

  return getCurrentLocation(state) && getOuterUrl(getCurrentLocation(state).pathname, sectionUrl);
};

export const getCurrentLocationSearch = state => get(getCurrentLocation(state), 'search', '');

export const isInPostPreview = state => detectRoute.isInPostPreview(getCurrentLocation(state));
